import React from 'react'
import { FormGroup, Input, Label } from 'reactstrap'
import { InputSelectOptions } from 'components/molecules'
import PropTypes from 'prop-types'

const SORT_DIR = {
  ASCENDING  : 'asc',
  DESCENDING : 'desc'
}

const PER_PAGE = {
  10  : '10',
  25  : '25',
  50  : '50',
  100 : '100'
}

const propTypes = {
  filterValues       : PropTypes.object,
  onSortFilterChange : PropTypes.func,
  sortByOptions      : PropTypes.object,
  isLoading          : PropTypes.bool
}

/**
 * Fields to set `sort_by`, `sort_dir`, and `per_page` filters
 * @param {Object} filterValues - current url filter values
 * @param {Object} onSortFilterChange - triggered when select field change
 * @param {Object} sortByOptions - options for `sort_by` select field
 * @param {Object} isLoading - loading state
 */

const SortAndPerPageFilters = ({
  filterValues,
  onSortFilterChange,
  sortByOptions,
  isLoading
}) => {
  const sortBy  = filterValues.sort_by || 'id'
  const sortDir = filterValues.sort_dir || 'desc'
  const perPage = filterValues.per_page || 10

  const isSortByOptionsExist = !!sortByOptions

  const SortByOptions = () => (
    Object.keys(sortByOptions).map((key) => {
      const label = sortByOptions[key].label
      const value = sortByOptions[key].value
      return (
        <option
          key={ `sort-by-option-${value}` }
          value={ value }
          className='text-capitalize'
        >
          { label }
        </option>
      )
    })
  )

  return (
    <div className='d-flex justify-content-end'>
      {
        isSortByOptionsExist && (
          <>
            { /* sort_by filter */ }
            <FormGroup className='mr-1'>
              <Label
                for={ 'sort_by' }
                className='small text-gray-light text-capitalize'
              >
                <strong>{ 'Sort By' }</strong>
              </Label>
              <Input
                type={ 'select' }
                name='sort_by'
                value={ sortBy }
                bsSize='sm'
                onChange={ onSortFilterChange }
                disabled={ isLoading }
              >
                <SortByOptions/>
              </Input>
            </FormGroup>

            { /* sort_dir filter */ }
            <FormGroup className='mr-1'>
              <Label
                for={ 'sort_dir' }
                className='small text-gray-light text-capitalize'
              >
                <strong>{ 'Sort Direction' }</strong>
              </Label>
              <Input
                type={ 'select' }
                name='sort_dir'
                value={ sortDir }
                bsSize='sm'
                onChange={ onSortFilterChange }
                disabled={ isLoading }
              >
                <InputSelectOptions
                  options={ SORT_DIR }
                />
              </Input>
            </FormGroup>
          </>
        )
      }


      { /* per_page filter */ }
      <FormGroup>
        <Label
          for={ 'per_page' }
          className='small text-gray-light text-capitalize'
        >
          <strong>{ 'Per Page' }</strong>
        </Label>
        <Input
          type={ 'select' }
          name='per_page'
          value={ perPage }
          bsSize='sm'
          onChange={ onSortFilterChange }
          disabled={ isLoading }
        >
          <InputSelectOptions
            options={ PER_PAGE }
          />
        </Input>
      </FormGroup>
    </div>
  )
}

SortAndPerPageFilters.propTypes = propTypes

export default SortAndPerPageFilters
